
import React, { useState, useRef, useMemo }  from 'react';
import Popover                      from '_views/shared/Popover';

import { toClassStr }               from '_utils/UiHelper';


const SubscriptionPlansPopover = ({ plans }) => {

  /*
  ==================================================
   HOOKS 
  ==================================================
  */

  const initialPlanName = 'year';
  const initialPlan = plans.find((plan) => plan.name.toLowerCase() === initialPlanName.toLowerCase()) || null;
  const [hovered, setHovered] = useState(false);
  const [activePlanId, setActivePlanId] = useState(initialPlan?.id || null);
  const [activePlanName, setActivePlanName] = useState(initialPlan?.name || null);
  const activePlanDetails = useMemo(() => {
    return (
      plans.find((plan) => plan.id === activePlanId) ||
      plans.find((plan) => plan.id === 30)
    );
  }, [activePlanId, plans]);
  let hoverTimeout = useRef();

  /*
  ==================================================
   EVENT HANDLERS
  ==================================================
  */

  const handleClosePopover = () => {
    setHovered(false);
  };

  const handleMouseEnter = () => {
    clearTimeout(hoverTimeout.current);
    setHovered(true);
  };
  
  const handleMouseLeave = () => {
    hoverTimeout.current = setTimeout(() => {
      setHovered(false);
    }, 150);
  };

  const handleSelectPlan = (planId) => {
    const selectedPlan = plans.find((plan) => plan.id === planId);
    if (selectedPlan) {
      setActivePlanId(planId);
      setActivePlanName(selectedPlan.name);
    }
  };

  console.log('Plans array: ', plans)

  /*
  ==================================================
   EVENT PUBLISHERS
  ==================================================
  */


  /*
  ==================================================
   EVENT TRIGGERS
  ==================================================
  */


  /*
  ==================================================
   LOCAL UTILS
  ==================================================
  */

  const getPlanDescription = (plan) => {
    const name = plan.name.trim().toLowerCase();
    if (name === "lifetime") return "One-time payment";
    return plan.billing_amount_and_frequency;
  };

  const getPlanFlag = (plan) => {
    return plan.name.trim().toLowerCase() === "semester" ? "Most Popular" : null;
  };

  const getPlanName = (plan) => {
    const name = plan.name.trim().toLowerCase();
    if (name === "semester") return `${plan.name} (Save 50%)`;
    if (name === "year") return `${plan.name} (Save 60%)`;
    return plan.name;
  };

  const getPlanPrice = (plan) => {
    const name = plan.name.trim().toLowerCase();
    if (name === "lifetime") return plan.dollars;
    return `$${plan.normalized_amount}`;
  };


  /*
  ==================================================
   SUB RENDERERS
  ==================================================
  */

  const renderPlanOption = (plan) => (
    <>
      <div className="option-content">
        <div className="option-title">{getPlanName(plan)}</div>
        <div className="option-description">{getPlanDescription(plan)}</div>
      </div>

      <div className="option-extras">
        {getPlanFlag(plan) && <div className="option-flag">{getPlanFlag(plan)}</div>}
        <div className="option-value">{getPlanPrice(plan)}</div>
      </div>
     </>
  );

  /*
  ==================================================
   EXPORTED COMPONENT  
  ==================================================
  */

  const isHovered = hovered ? 'active' : '';
  const classes = toClassStr(['dynamic-plans-pricing', isHovered]);

  return (
    <div
      className={classes}
      data-plan-id={activePlanId}
      data-plan-name={activePlanName}
      onMouseEnter={() => handleMouseEnter()}
      onMouseLeave={() => handleMouseLeave()}
    >

      <h3>{getPlanPrice(activePlanDetails)}</h3>
      <span>{getPlanName(activePlanDetails)}</span>

      {hovered && (
        <Popover
          addClasses='plans-popover'
          activePlan={activePlanId}
          // onSelectPlan={setActivePlanId}
          onSelectPlan={handleSelectPlan} 
          onClose={handleClosePopover}
          options={plans}
          renderOption={renderPlanOption}
          heading='Choose your subscription plan'
        />
      )}
    </div>
  );
};

export default SubscriptionPlansPopover;
